module.exports = __webpack_public_path__ + "static/media/casaVictor.c50d77f0.png";